// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3TmQW","xxsmall":"_3U2jb","xsmall":"_2A9cy","small":"_25Dca","medium":"_2iwjn","large":"jbvvS","xlarge":"zvyIg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.scss
// module id = ./src/components/Avatar/Avatar.scss
// module chunks = 5